import * as React from 'react'
import { toast } from '@sales-center/components'

import { DeleteDialog } from './DeleteDialog'
import type { DeleteProps } from './useDelete'
import { useAppDispatch } from '@user/store/hooks'
import { removeCustomField } from '@user/store/customFields'

export function DeleteCustomField(props: DeleteProps) {
  const { deleteId, closeDelete, loading, usageCount, onTransitionEnd } = props
  const [isLoading, setIsLoading] = React.useState(false)

  const open = deleteId !== undefined

  const dispatch = useAppDispatch()

  const okClick = React.useCallback(async () => {
    if (!!deleteId) {
      setIsLoading(true)
      const response = await dispatch(removeCustomField(deleteId))

      if (removeCustomField.fulfilled.match(response)) {
        setIsLoading(false)
        toast.success('Custom Field Deleted')
      } else {
        setIsLoading(false)
        toast.error('Unable to delete Custom Field')
      }

      closeDelete()
    }
  }, [closeDelete, deleteId, dispatch])

  return (
    <DeleteDialog
      open={open}
      loading={loading || isLoading}
      onDelete={okClick}
      onClose={closeDelete}
      usageCount={usageCount}
      onTransitionEnd={onTransitionEnd}
    />
  )
}
